import { SafeHtml } from "@angular/platform-browser";

export class DoctorReferral {
    doctor_referred_user_guid: string;
    specialty_id: string;
    name: string;
    d_email: string;
    country_id: string;
    state_name: string;
    city: string;
    contact: string;
}

export class getDoctorReferal {
    current_user_guid: string;
    user_guid: string;
    profession_type: string;
}

export class ReferralDoctorsModel {
    doctor_guid: string;
    d_email: string;
    name: string;
    state_name: string;
    city: string;
    approved_by_guid: string;
    approved_by_name: string;
    request_sent_date: Date;
    request_approved_date: Date;
    contact: string;
    status: string;
    created_at: Date;
    updated_at: Date;
    doctor_referred_name: string;
    user_guid: string;
    d_specialty_type: {
        specialty_name: string;
    };
    country: {
        country_name: string;
    };
    profession_type: string;
}

export class Referral_Action {
    action_id: number;
    current_user_guid: String;
}

export class agreement_data {
    document_id: string;
    document_body: SafeHtml;
    document_version: string;
}

export enum profession_type {
    doctor = 'doctor',
    other_medic = 'other_medic'
}
